<template>
    <div>
      <v-dialog v-model="open" max-width="550" persistent>
        <v-card>
          <v-card-title class="headline mb-4">{{ title }}</v-card-title>
  
          <v-card-text>
            <div class="row">
              <div class="col-md-12">
                <DatePickerEsp
                    :initToday="true"
                    label="Fecha estimada de entrega"
                    :date="sale_order.estimated_delvery_date"
                    :isRequired="true"
                    name="estimated_delvery_date"
                    
                    @setDate="
                    (date) => {
                        sale_order.estimated_delvery_date = date;
                    }
                    "
                />
                <v-checkbox label="Entregado" v-model="sale_order.delivered"></v-checkbox>
               
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>  
            <v-btn color="red darken-1" text @click="close()"> Cancelar </v-btn>
            <div>
              <v-btn color="green darken-1" text @click="generateSaleOrder" :loading="loading"> {{ "Editar" }} </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  <script>
  import { saleOrderService } from "@/libs/ws/saleOrderService";
  
  import { formatUtils } from "@/libs/utils/formatUtils";
  import SettingsMixin from "@/mixins/SettingsMixin.vue";
  import DatePickerEsp from "@/components/DatePickerEsp.vue";


  export default {
    components: { DatePickerEsp  },
    mixins: [SettingsMixin],
    props: {
      title: String,
      checkbox_label: String,
      open: Boolean,
      
      closeDialog: Function,
      reload: Function,
      cancel: Function,
      item: Object,
      updateMainItem: Function,
  
    },
    data: () => ({
      saleOrderService: saleOrderService,
      loading: false,
      formatUtils: formatUtils,
      sale_order: {
        id: "",
        estimated_delvery_date: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        delivered: false
      },
      defaultSaleOrder: null
    }),
    created: function () {
      window.addEventListener("keydown", (e) => {
        if (e.key == "Escape") {
          this.close();
        }
      });
    },
    watch: {
      open: function (val) {
        if (this.item && this.item.id != "") {
          this.sale_order = JSON.parse(JSON.stringify(this.item));

          console.log("sale_order", this.sale_order)
        }
      },
    },
    mounted() {
      this.defaultSaleOrder = JSON.parse(JSON.stringify(this.sale_order));
    },
    methods: {
      close() {
        this.sale_order = JSON.parse(JSON.stringify(this.defaultSaleOrder));
  
        this.$emit("updateMainItem");
        this.$emit("closeDialog");
      },
      generateSaleOrder(event) {
        this.$validator.validate().then((valid) => {
          if (valid) {
            let data = this.getParams();

            this.loading = true;

            if (this.sale_order && this.sale_order.id > 0) {
              saleOrderService
                .update_delivered(data)
                .then((response) => {
                  if (response.status) {
                    this.$toast.success("La Orden de Venta se editó correctamente", "OK");
  
                    this.sale_order = JSON.parse(JSON.stringify(this.defaultSaleOrder));
                    this.$emit("reload");
                    this.close();
                  } else {
                    if (Object.prototype.hasOwnProperty.call(response, "message")) {
                      this.$toast.error(response.message, "Error");
                    } else {
                      if (Object.prototype.hasOwnProperty.call(response, "message")) {
                        this.$toast.error(response.message, "Error");
                      } else {
                        this.$toast.error(response.msg, "Error");
                      }
                    }
                  }
                })
                .catch((response) => {
                  this.$toast.error(response.msg, "Error");
                })
                .finally(() => {
                  this.loading = false;
                });
            }
          } else {
            this.$toast.error("Complete los campos requeridos", "Error");
          }
        });
      },
      
      getParams() {
        
        let data = {
          id: this.sale_order.id,
          delivered: this.sale_order.delivered,
          estimated_delvery_date: this.sale_order.estimated_delvery_date,
        }

        return data;
      }
    },
  };
  </script>
  